import * as Yup from "yup";
import {FIELD_NUMBER, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as consultationPackageFormNames from "./consultationPackagesFormNames";

export const consultationPackageValidationSchema = Yup.object().shape({
  [consultationPackageFormNames.CODE_PACKAGE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationPackageFormNames.ROLE_OPERATEUR_FORM_NAME]:
    Yup.number().typeError(FIELD_NUMBER),
  [consultationPackageFormNames.STATUS_PACKAGE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationPackageFormNames.TYPE_PAIEMENT_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationPackageFormNames.TRANSACTION_AUTORISEE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME]:
    Yup.number().typeError(FIELD_NUMBER),
  [consultationPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
});
